import { render, staticRenderFns } from "./SavingsCashflowTrend.vue?vue&type=template&id=60e49995&scoped=true"
import script from "./SavingsCashflowTrend.vue?vue&type=script&lang=js"
export * from "./SavingsCashflowTrend.vue?vue&type=script&lang=js"
import style0 from "./SavingsCashflowTrend.vue?vue&type=style&index=0&id=60e49995&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e49995",
  null
  
)

export default component.exports